import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      PORTIONS: "porsjoner",
      INCREASE_NUM_PORTIONS: "Øk antall porsjoner",
      DECREASE_NUM_PORTIONS: "Reduser antall porsjoner",
    },
    se: {
      PORTIONS: "portioner",
      INCREASE_NUM_PORTIONS: "Öka antal portioner",
      DECREASE_NUM_PORTIONS: "Minska antal portioner",
    },
    dk: {
      PORTIONS: "portioner",
      INCREASE_NUM_PORTIONS: "Øg antal portioner",
      DECREASE_NUM_PORTIONS: "Reducer antal portioner",
    },
  } as const
)[language];
